//@flow

import React from 'react';
import type {VideoType} from 'app/video/types';
import {gt} from 'app/utils/i18n';

type Props = {
  ratio: string,
  width: number,
  height: number,
  video: VideoType,
  videoPlaceholder?: string,

  canAutoplay: boolean,
  videoStartedPlaying: (videoId: string) => void,
  videoStoppedPlaying: (videoId: string) => void,
};

export class VideoObject extends React.PureComponent<Props> {
  ref: null | HTMLVideoElement;

  onPlayMethod = () => {
    this.props.videoStartedPlaying(this.props.video.hashid);
  };

  onStoppedPlayingMethod = () => {
    this.props.videoStoppedPlaying(this.props.video.hashid);
  };

  setReference = (node: null | HTMLVideoElement) => {
    if (node != null && this.ref == null) {
      const ref = (this.ref = node);
      ref.addEventListener('play', this.onPlayMethod);
      ref.addEventListener('pause', this.onStoppedPlayingMethod);
      ref.addEventListener('ended', this.onStoppedPlayingMethod);
    }
  };

  componentWillUnmount() {
    if (this.ref != null) {
      const ref = this.ref;
      ref.removeEventListener('play', this.onPlayMethod);
      ref.removeEventListener('pause', this.onStoppedPlayingMethod);
      ref.removeEventListener('ended', this.onStoppedPlayingMethod);
      this.ref = null;
    }
  }

  render() {
    const {ratio, width, height, canAutoplay, video, videoPlaceholder} =
      this.props;

    return (
      <div className="embedded-obj" style={{paddingBottom: ratio}}>
        <video
          ref={this.setReference}
          width={width}
          height={height}
          controls={true}
          playsInline={true}
          autoPlay={canAutoplay}
          placeholder={videoPlaceholder}
          muted
          src={video.src_url}
        >
          {gt('This browser does not support video streaming')}
        </video>
      </div>
    );
  }
}
